import * as type from './mutation-types'
const mutations = {
    [type.GET_USERINFO] (state, res) {
        state.userInfo = res
    },
    [type.GET_FOLDERS] (state, res) {
        let folders = res.data.folders
        let mailFolders = {
            'multiMails': [],
            'other': []
        }
        let foldersLength = folders.length
        for (let i = 0; i < foldersLength; i++) {
            let fOne = folders[i]
            let folderName = fOne.name
            let name = ''
            if (fOne.type === 'sys') {
                if (state.folderIndex[folderName]) {
                    name = state.folderIndex[folderName]
                }
            }
            if (name) {
                mailFolders[name] = fOne
            } else {
                if (fOne.type !== 'sys') {
                    mailFolders[fOne.type].push(fOne)
                }
            }
        }

        mailFolders['multiMails'] = mailFolders['multiMails']
        mailFolders['other'] = mailFolders['other']
        state.mailFolders = mailFolders
        state.originFolders = folders
    },
    [type.SAVE_MAILSLIST] (state, mailsList) {
        state.mailsList = mailsList
    },
    [type.CHANGE_SELECTALL] (state, selectall) {
        state.selectAll = selectall
    },
    [type.CHANGE_MAILSORT] (state, sort) {
        state.mailSort = sort
    },
    [type.SAVE_SELECTIDS] (state, ids) {
        state.selectIds = ids
        state.ids = ids
    },
    [type.SAVE_ORIGINLIST] (state, list) {
        state.list = list
    },
    [type.SAVE_FOLEDERID] (state, id) {
        state.folderId = id
    },
    [type.SAVE_MAILDATA] (state, maildata) {
        state.mailData = maildata
    },
    [type.SAVE_BASESET] (state, base) {
        state.baseSet = base
    },
    [type.LOGIN] (state, status) {
        state.login = !!status
    },
    [type.SAVE_SKIN] (state, data) {
        state.skin = data
    },
    [type.SET_COLUMN] (state, status) {
        state.column = !!status
        localStorage.setItem(state.userInfo.email + '_column', state.column)
    },
    [type.SET_DIALOG] (state, status) {
        state.dialog = !!status
        localStorage.setItem(state.userInfo.email + '_dialog', state.dialog)
    },
    [type.GET_CONTACT_LIST] (state, res) {
        state.contact = res
    },
    [type.SET_SEAECH_TEXT] (state, res) {
        state.searchText = res
    }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js